// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2HZ1k","active":"downloadDropdown_active__2Ugrh"};